<div class="container cpal">
  <div class="row mb-5">
    <h2>Ofertas de Crédito</h2>
  </div>

  <mat-table [dataSource]="ofertas" class="mb-5">
    <ng-container matColumnDef="montoAprobado">
      <mat-header-cell *matHeaderCellDef>Monto Aprobado</mat-header-cell>
      <mat-cell *matCellDef="let oferta">{{ oferta.montoAprobado }}</mat-cell>
    </ng-container>
  
    <ng-container matColumnDef="tasaInteresAnual">
      <mat-header-cell *matHeaderCellDef>Tasa Interés Anual</mat-header-cell>
      <mat-cell *matCellDef="let oferta">{{ oferta.tasaInteresAnual }}%</mat-cell>
    </ng-container>
  
    <ng-container matColumnDef="tasaInteresMensual">
      <mat-header-cell *matHeaderCellDef>Tasa Interés Mensual</mat-header-cell>
      <mat-cell *matCellDef="let oferta">{{ oferta.tasaInteresMensual }}%</mat-cell>
    </ng-container>
  
    <ng-container matColumnDef="cargaAnualEquivalente">
      <mat-header-cell *matHeaderCellDef>Carga Anual Equivalente</mat-header-cell>
      <mat-cell *matCellDef="let oferta">{{ oferta.cargaAnualEquivalente }}%</mat-cell>
    </ng-container>
  
    <ng-container matColumnDef="periodoMeses">
      <mat-header-cell *matHeaderCellDef>Periodo (Meses)</mat-header-cell>
      <mat-cell *matCellDef="let oferta">{{ oferta.periodoMeses }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="gastosNotario">
      <mat-header-cell *matHeaderCellDef>Gastos Notario</mat-header-cell>
      <mat-cell *matCellDef="let oferta">{{ oferta.gastosNotario }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="impuestos">
      <mat-header-cell *matHeaderCellDef>Impuestos</mat-header-cell>
      <mat-cell *matCellDef="let oferta">{{ oferta.impuestos }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="costoTotalCredito">
      <mat-header-cell *matHeaderCellDef>Costo Total Crédito</mat-header-cell>
      <mat-cell *matCellDef="let oferta">{{ oferta.costoTotalCredito }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="valorMensualCuota">
      <mat-header-cell *matHeaderCellDef>Valor Mensual Cuota</mat-header-cell>
      <mat-cell *matCellDef="let oferta">{{ oferta.valorMensualCuota }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="fechaCaducidad">
      <mat-header-cell *matHeaderCellDef>Fecha Caducidad</mat-header-cell>
      <mat-cell *matCellDef="let oferta">{{ oferta.fechaCaducidad | date:'dd-MM-yyyy' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="acciones">
      <mat-header-cell *matHeaderCellDef>Acciones</mat-header-cell>
      <mat-cell *matCellDef="let oferta">
        <button mat-icon-button [routerLink]="['/solicitudes', oferta.solicitudCreditoId, 'ofertas', oferta.guid]">
          <mat-icon>visibility</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="['montoAprobado', 'tasaInteresAnual', 'tasaInteresMensual', 'cargaAnualEquivalente', 'periodoMeses', 'gastosNotario', 'impuestos', 'costoTotalCredito', 'valorMensualCuota', 'fechaCaducidad', 'acciones']"></mat-header-row>
    <mat-row *matRowDef="let row; columns: ['montoAprobado', 'tasaInteresAnual', 'tasaInteresMensual', 'cargaAnualEquivalente', 'periodoMeses', 'gastosNotario', 'impuestos', 'costoTotalCredito', 'valorMensualCuota', 'fechaCaducidad', 'acciones']"></mat-row>
  </mat-table>
</div>